<template>
  <section class="section">
    <!-- Create Employee -->
    <transition name="fade">
      <div class="card" v-if="createState">
        <div class="card-content">
          <div class="columns is-desktop">
            <div class="column is-4">
              <div class="file is-medium is-boxed has-name">
                <label class="file-label" style="width: 100%;">
                  <input
                    class="file-input"
                    type="file"
                    accept=".xlsx,.xls"
                    @change="uploadData"
                    name="uploadFileEmployeeCl7"
                  />
                  <span class="file-cta">
                    <span class="file-icon">
                      <i class="fas fa-upload"></i>
                    </span>
                    <span
                      class="file-label has-text-centered"
                      style="justify-content: center"
                    >
                      <i class="material-icons">cloud_upload</i>
                      <div class="is-size-7">
                        Clic para subir un archivo xlsx
                      </div>
                    </span>
                  </span>
                  <span
                    class="file-name has-text-centered text-dots"
                    style="width: 100%; max-width: 100%"
                  >
                    {{ forms.nameFile ? forms.nameFile : "..." }}
                  </span>
                </label>
              </div>
              <br />
              <div class="file has-name" @click="downloadExample">
                <label class="file-label" style="width: 100%;">
                  <span class="file-cta has-text-centered">
                    <span class="file-icon">
                      <i class="material-icons">description</i>
                    </span>
                  </span>
                  <span class="file-name" style="max-width: none; width: 100%;">
                    Descargar de plantilla
                  </span>
                </label>
              </div>
            </div>
            <div class="column is-8">
              <div class="field">
                <span class="subtitle">
                  Introduce la siguiente información para crear un empleado
                  manualmente
                </span>
                <div class="field" style="margin-top: 7px;">
                  <div
                    class="control has-icons-left"
                    :class="{ 'has-icons-right': forms.errors.email }"
                  >
                    <input
                      v-model="employee.email"
                      class="input"
                      :class="{ 'is-danger': forms.errors.email }"
                      type="email"
                      placeholder="Correo"
                      required
                      id="email"
                      name="email"
                    />
                    <span class="icon is-small is-left">
                      <i class="material-icons">email</i>
                    </span>
                    <span
                      v-show="forms.errors.email"
                      class="icon is-small is-right"
                    >
                      <i class="material-icons">error</i>
                    </span>
                    <p v-show="forms.errors.email" class="help is-danger">
                      Este campo es requerido.
                    </p>
                  </div>
                </div>
                <div class="columns">
                  <div class="field column">
                    <div
                      class="control has-icons-left"
                      :class="{ 'has-icons-right': forms.errors.nameEmployee }"
                    >
                      <input
                        v-model="employee.nombre"
                        class="input"
                        :class="{ 'is-danger': forms.errors.nameEmployee }"
                        type="text"
                        placeholder="Nombre"
                        id="name"
                        name="name"
                      />
                      <span class="icon is-small is-left">
                        <i class="material-icons">face</i>
                      </span>
                      <span
                        v-show="forms.errors.nameEmployee"
                        class="icon is-small is-right"
                      >
                        <i class="material-icons">error</i>
                      </span>
                      <p
                        v-show="forms.errors.nameEmployee"
                        class="help is-danger"
                      >
                        Este campo es requerido.
                      </p>
                    </div>
                  </div>
                  <div class="field column">
                    <div
                      class="control has-icons-left"
                      :class="{
                        'has-icons-right': forms.errors.identification,
                      }"
                    >
                      <input
                        v-model="employee.cedula"
                        class="input"
                        :class="{ 'is-danger': forms.errors.identification }"
                        type="text"
                        placeholder="Cédula"
                        id="cedula"
                        name="cedula"
                      />
                      <span class="icon is-small is-left">
                        <i class="material-icons">featured_play_list</i>
                      </span>
                      <span
                        v-show="forms.errors.identification"
                        class="icon is-small is-right"
                      >
                        <i class="material-icons">error</i>
                      </span>
                      <p
                        v-show="forms.errors.identification"
                        class="help is-danger"
                      >
                        Este campo es requerido.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="columns is-multiline">
                  <div
                    class="field column is-6"
                    v-for="(item, index) in dependencies"
                    :key="index"
                  >
                    <div class="control has-icons-left">
                      <input
                        v-model="employee.dependencias[item._id]"
                        class="input"
                        type="text"
                        :placeholder="item.nombre"
                        :id="`dependence_${item.nombre}`"
                        :name="`dependence_${item.nombre}`"
                      />
                      <span class="icon is-small is-left">
                        <i class="material-icons">group</i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="buttons">
                  <button class="button is-link" @click="saveEmployee()">
                    Guardar
                  </button>
                  <button class="button is-light" @click="switchForms(true)">
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- Create and List dependencies -->
    <transition name="fade">
      <div class="card" v-if="dependenceState">
        <div class="card-content">
          <div class="field">
            <span class="subtitle">
              Introduce la siguiente información para crear una dependencia
            </span>
            <div class="field is-grouped" style="margin-top: 7px;">
              <div
                class="control has-icons-left is-expanded"
                :class="{ 'has-icons-right': forms.errors.nameDependence }"
              >
                <input
                  v-model="dependence.nombre"
                  class="input"
                  :class="{ 'is-danger': forms.errors.nameDependence }"
                  type="text"
                  placeholder="Nombre"
                  id="name"
                  name="name"
                />
                <span class="icon is-small is-left">
                  <i class="material-icons">email</i>
                </span>
                <span
                  v-show="forms.errors.nameDependence"
                  class="icon is-small is-right"
                >
                  <i class="material-icons">error</i>
                </span>
                <p v-show="forms.errors.nameDependence" class="help is-danger">
                  Este campo es requerido.
                </p>
              </div>
              <div class="control is-flex">
                <a
                  class="button is-dark"
                  style="margin-right: 5px"
                  v-on:click="createDependence"
                >
                  Guardar
                </a>
                <a class="button is-danger" v-on:click="switchForms(false)">
                  Cancelar
                </a>
              </div>
            </div>
            <table-ag
              :row-data="dependencies"
              :column-defs="columnsDependence"
              :components="componentDependence"
              :actions="true"
              :pagination="false"
              :auto-height="true"
            ></table-ag>
          </div>
        </div>
      </div>
    </transition>
    <br />
    <!-- Progress -->
    <progress
      v-show="forms.advanceUpload > 0"
      class="progress is-info is-small"
      :value="forms.advanceUpload"
      max="100"
    ></progress>

    <!-- Table -->
    <table-ag
      ref="tableEmployeesCl7"
      :row-data="employees"
      :column-defs="columns"
      :components="components"
      :component-menu="componentMenu"
      :actions="true"
      :pagination="false"
      :auto-height="true"
    ></table-ag>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
import tableAg from "../dashboard/tableAg.vue";
import { mapState } from "vuex";
import MenuTableEmployee from "./components/menuTableEmployee.vue";
import ButtonsActionEmployees from "./components/buttonsActionEmployees.vue";
import ButtonsActionDependence from "./components/buttonsActionDependence.vue";
import _f from "@/helpers/functions";
import { runExcelUpload } from "./upload/flow";
import { classifyError } from "./upload/analysis";

export default {
  data() {
    return {
      employees: [],
      dependencies: [],
      columns: [
        {
          field: "nombre",
          headerName: "Nombre",
          tooltipValueGetter: (params) => {
            return params.value;
          },
          editable: false,
          def: true,
        },
        {
          field: "cedula",
          headerName: "Cédula",
          editable: false,
          def: true,
        },
        {
          field: "email",
          headerName: "Correo",
          editable: false,
          def: true,
        },
        {
          field: "_id",
          headerName: "Controles",
          colId: "_actions",
          editable: false,
          def: true,
          cellRenderer: "ButtonsActionEmployeeCl7",
          sortable: false,
          width: 90,
          pinned: "right",
        },
      ],
      columnsDependence: [
        {
          field: "nombre",
          headerName: "Nombre",
          tooltipValueGetter: (params) => {
            return params.value;
          },
          editable: false,
        },
        {
          field: "_id",
          headerName: "Controles",
          colId: "_actions",
          editable: false,
          cellRenderer: "ButtonsActionDependenceCl7",
          sortable: false,
          width: 10,
          pinned: "right",
        },
      ],
      columnShowDepend: {
        editable: false,
        def: true,
        resizable: false,
        filter: false,
        headerComponent: "HeaderDepend",
        headerComponentParams: { icon: "visibility" },
        width: 20,
      },
      componentMenu: () => {
        return {
          render: (h) =>
            h(MenuTableEmployee, {
              props: {
                proceso: this.proceso,
                createState: this.createState,
                dependenceState: this.dependenceState,
                employeesCount: this.employees.length,
              },
              on: {
                switchForms: this.switchForms,
                getEmployees: this.getEmployees,
                downloadEmployees: this.downloadEmployees,
              },
            }),
        };
      },
      components: {
        ButtonsActionEmployeeCl7: () => {
          return {
            render: (h) =>
              h(ButtonsActionEmployees, {
                props: {
                  proceso: this.proceso,
                },
                on: {
                  getEmployees: this.getEmployees,
                  editEmployee: this.editEmployee,
                },
              }),
          };
        },
      },
      componentDependence: {
        ButtonsActionDependenceCl7: () => {
          return {
            render: (h) =>
              h(ButtonsActionDependence, {
                props: {
                  proceso: this.proceso,
                },
                on: {
                  getEmployees: this.getEmployees,
                },
              }),
          };
        },
      },
      forms: {
        advanceUpload: 0,
        nameFile: null,
        errors: {
          nameEmployee: false,
          email: false,
          identification: false,
          nameDependence: false,
        },
      },
      createState: false,
      dependenceState: false,
      employee: {
        nombre: "",
        email: "",
        proceso: this.proceso._id,
        dependencias: {},
      },
      dependence: {
        nombre: "",
      },
    };
  },
  props: {
    proceso: {
      type: Object,
    },
  },
  computed: {
    ...mapState(["idtoken"]),
  },
  beforeMount() {
    this.$emit("calculateProcess");
  },
  methods: {
    // Table
    async getEmployees() {
      try {
        const result = await apiServices.get(
          `/colaboradoresclimalist/${this.proceso._id}`,
        );
        if (result.data) {
          this.employees = result.data.colaboradores;
          this.dependencies = result.data.dependencias;
          this.updateColumns(result.data.dependencias);
        }
        return true;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    async getDependencies() {
      try {
        const result = await apiServices.get(
          `/getdependenciaclima/${this.proceso._id}`,
        );
        if (result.data) {
          this.dependencies = result.data;
          // this.updateColumns(result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    // Actions
    async saveEmployee() {
      const validateForm = this.validateForm("employee");
      const update = !!this.employee._id;
      if (validateForm) {
        try {
          let result;
          if (update) {
            result = await apiServices.post(
              `/editcolaboradorclima`,
              this.employee,
            );
          } else {
            result = await apiServices.post(
              `/savecolaboradorclima`,
              this.employee,
            );
          }
          if (result.data) {
            await this.$swal({
              text: `Empleado ${
                update ? "actualizado" : "creado"
              } correctamente.`,
              icon: "success",
              showConfirmButton: false,
              timer: 1700,
            });
            await this.getEmployees();
            this.switchForms(true);
          }
        } catch (err) {
          console.log(err);
          await this.$swal({
            text: `Error al ${update ? "actualizar" : "crear"} el empleado.`,
            icon: "error",
            showConfirmButton: false,
            timer: 1700,
          });
        }
      }
    },
    async createDependence() {
      const validateForm = this.validateForm("dependence");
      if (validateForm) {
        try {
          const result = await apiServices.post(`/savedependenciaclima`, {
            dependencia: this.dependence,
            proceso: this.proceso._id,
          });
          if (result.data) {
            await this.$swal({
              text: "Dependencia creada correctamente.",
              icon: "success",
              showConfirmButton: false,
              timer: 1700,
            });
            await this.getEmployees();
          }
          this.dependence.nombre = null;
        } catch (err) {
          console.log(err);
          const info = classifyError(err);
          await this.$swal({
            text:
              info.kind === "message"
                ? info.message
                : "Error al crear la dependencia.",
            icon: "error",
            showConfirmButton: false,
            timer: 1700,
          });
        }
      }
    },
    editEmployee(d) {
      this.employee.nombre = d.nombre;
      this.employee.email = d.email;
      this.employee.cedula = d.cedula;
      this.employee.proceso = this.proceso._id;
      this.employee.dependencias = d.dependencias;
      this.employee._id = d._id;
      this.createState = true;
      this.scrollTop();
    },
    switchForms(d) {
      if (d) {
        if (this.dependenceState) this.switchForms(false);
        this.createState = !this.createState;
        if (!this.createState)
          this.employee = {
            nombre: "",
            email: "",
            proceso: this.proceso._id,
            dependencias: {},
          };
      } else {
        if (this.createState) this.switchForms(true);
        this.dependenceState = !this.dependenceState;
        if (!this.dependenceState)
          this.dependence = {
            nombre: "",
          };
      }
    },
    updateColumns(d) {
      if (d.length) {
        const dependencies = d.map((x) => {
          return {
            field: "dependencias",
            headerName: _f.capitalize(x.nombre.toLowerCase()),
            valueGetter: (params) => {
              const dependecies = params.data[params.colDef.field];
              return dependecies ? dependecies[x._id] || null : null;
            },
            editable: false,
            resizable: true,
            width: 120,
            tooltipValueGetter: (params) => {
              return params.value;
            },
            hide: true,
          };
        });
        let first = true;
        const columns = this.columns.filter((x) => {
          if (x.headerComponent === "HeaderDepend") {
            first = false;
          }
          if (x.def) return true;
        });
        this.columns = first
          ? columns.concat([this.columnShowDepend, ...dependencies])
          : columns.concat(dependencies);
      }
      this.resizeTable();
    },
    // Others
    validateForm(d) {
      const forms = {
        employee: this.employee,
        dependence: this.dependence,
      };
      const names = {
        name: d === "employees" ? "nameEmployee" : "nameDependence",
        cedula: "identification",
      };
      return Object.entries(forms[d]).filter(([k, x]) => {
        this.forms.errors[names[k]] = !x;
        if (x) return true;
      }).length;
    },
    async downloadExample() {
      try {
        let result;
        result = await apiServices.post(
          `/downexempleempleados`,
          { proceso: this.proceso._id },
          { responseType: "blob" },
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Ejemplo de empleados - CL7.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        await this.$store.dispatch("notify", {
          message: `Ejemplo descargado correctamente.`,
          type: "is-link",
        });
      } catch (e) {
        console.log(e);
        await this.$store.dispatch("notify", {
          message: `Error al descargado el ejemplo.`,
          type: "is-danger",
        });
      }
    },
    async downloadEmployees() {
      try {
        const result = await apiServices.post(
          `/downempleadosclima`,
          { proceso: this.proceso._id },
          { responseType: "blob" },
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        // El nombre del proceso puede traer caracteres que no valen en un archivo.
        const nombre = (this.proceso.nombre || "CL7").replace(
          /[\\/:*?"<>|]/g,
          "-",
        );
        link.href = url;
        link.setAttribute("download", `Empleados - ${nombre}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        await this.$store.dispatch("notify", {
          message: `Empleados descargados correctamente.`,
          type: "is-link",
        });
      } catch (e) {
        console.log(e);
        await this.$store.dispatch("notify", {
          message: `Error al descargar los empleados.`,
          type: "is-danger",
        });
      }
    },
    uploadData(e) {
      const input = e.target;
      const file = input.files && input.files[0];
      if (!file) return;
      return runExcelUpload(this, {
        file,
        input,
        proceso: this.proceso._id,
        tipo: "colaboradores",
        batchPath: "/saveempleadoslote1",
        onProgress: (value) => {
          this.forms.advanceUpload = value;
        },
        refresh: this.getEmployees,
        refreshOnBatchMessage: true,
      });
    },
    scrollTop() {
      window.scrollTo({
        behavior: "smooth",
        left: 0,
        top: 200,
      });
    },
    resizeTable() {
      const table = this.$refs.tableEmployeesCl7;
      table.resetGrid();
    },
  },
  created() {
    this.getEmployees();
  },
  watch: {},
  components: { tableAg },
};
</script>
<style lang="scss">
.ag-pre-table .ag-header-cell-label {
  justify-content: center !important;
}
.ag-pre-table .ag-header-cell {
  justify-content: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/Employees.vue